import React, { createContext, useContext, useState, ReactNode } from "react";
import { otherConfigOptionsAttributes } from "../../salescodeStudio/mandatoryConfigs/configSetupScreen/widget/configBottomBar";

// Type for context value
interface FeatureSelectionOptionsContextType {
  uiConfigOptionsProp?: otherConfigOptionsAttributes[];
  setUiConfigOptionsProp?: React.Dispatch<
    React.SetStateAction<otherConfigOptionsAttributes[]>
  >;
  featureChangeList?:string[];
  setFeatureChangeList?:React.Dispatch<React.SetStateAction<string[]>>
  setOnSaved?:React.Dispatch<React.SetStateAction<boolean>>
  onSaved?:boolean
}

export const FeatureSelectionOptionsContext = createContext<FeatureSelectionOptionsContextType>({
  uiConfigOptionsProp: [],
  setUiConfigOptionsProp: () => {},
  featureChangeList:[],
  setFeatureChangeList:()=>{},
  setOnSaved:()=>{},
  onSaved:false,
});